import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../../common/theme/ISpcTheme';

export type SummaryCashClasses = 'price' | 'pricesContainer' | 'pricesWrapper' | 'priceLabel';

const summaryCashStyles = makeStyles<ISpcTheme, SummaryCashClasses>(
  theme => ({
    price: {
      color: theme.palette.primary.main,
      fontFamily: theme.typography.fontFamily2,
      display: 'flex',
      alignItems: 'center',
    },
    pricesWrapper: {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
    },
    pricesContainer: {
      width: '100%',
      display: 'flex',
      fontSize: theme.typography.fontXL,
      alignItems: 'center',
      justifyContent: 'center',
    },
    priceLabel: {
      fontSize: theme.typography.fontXS,
    },
  }),
  { name: 'ConfigSummary_SummaryCash' },
);

export default summaryCashStyles;
